import { residenceCatalogGuard } from '@partners/catalog';
import { ContextBuilder } from '../http';

export const provideResidenceCatalogGuard = (): (() => Promise<boolean>) => {
  return async () => {
    const context = new ContextBuilder().addUrlModifiers({ omitProcess: true }).build();
    return await residenceCatalogGuard({ context });
  };
};
